import type { GraphQLTypes, InputType } from '@zeus/index'
import { $, Selector } from '@zeus/index'
import { typedGql } from '@zeus/typedDocumentNode'
import { scalars } from '~/gql/utils/scalars'

/**
 * Liste : compteur seul, sans les membres. Les charger pour chaque groupe
 * remplirait l'écran de gestion de données que ses lignes n'affichent pas.
 */
const groupSelector = Selector('GroupModel')({
  id: true,
  name: true,
  description: true,
  memberCount: true,
})

/** Détail : le picker de membres a besoin de la composition du groupe. */
const groupWithMembersSelector = Selector('GroupModel')({
  ...groupSelector,
  members: {
    id: true,
    email: true,
    firstName: true,
    lastName: true,
  },
})

export const GQL_GROUPS = typedGql('query', { scalars })({
  groups: groupSelector,
})

export const GQL_GROUP = typedGql('query', { scalars })({
  group: [{ id: $('id', 'ID!') }, groupWithMembersSelector],
})

export const GQL_CREATE_GROUP = typedGql('mutation', { scalars })({
  createGroup: [{ input: $('input', 'CreateGroupInput!') }, groupSelector],
})

export const GQL_UPDATE_GROUP = typedGql('mutation', { scalars })({
  updateGroup: [
    { id: $('id', 'ID!'), input: $('input', 'UpdateGroupInput!') },
    groupSelector,
  ],
})

export const GQL_DELETE_GROUP = typedGql('mutation')({
  deleteGroup: [{ id: $('id', 'ID!') }, true],
})

export const GQL_ADD_USERS_TO_GROUP = typedGql('mutation')({
  addUsersToGroup: [
    { groupId: $('groupId', 'ID!'), userIds: $('userIds', '[ID!]!') },
    true,
  ],
})

export const GQL_REMOVE_USERS_FROM_GROUP = typedGql('mutation')({
  removeUsersFromGroup: [
    { groupId: $('groupId', 'ID!'), userIds: $('userIds', '[ID!]!') },
    true,
  ],
})

export type StoredGroup = InputType<
  GraphQLTypes['GroupModel'],
  typeof groupSelector,
typeof scalars
>

export type StoredGroupWithMembers = InputType<
  GraphQLTypes['GroupModel'],
  typeof groupWithMembersSelector,
typeof scalars
>
